import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { selectUser, isAnonymousUser } from "redux/authReducer";
import { resetStore } from "redux/CreateDataset/actions";
import {
  setShowDSCreationWarning,
  setShowSignUpModal,
} from "redux/Modals/actions";
import {
  CREATE_NEW_DATASET,
  SIGNUP_ORIGIN,
} from "helpers/constants/amplitudeProperties";
import { isOnPremUser } from "helpers/utility/utilities";
import { useFeatureFlagService } from "hooks/useFeatureFlagService";
import { DATASET_INGESTION_ON_PREM } from "helpers/constants/filters";
import useCreateDataset from "hooks/useCreateDataset";

export function useHandleDatasetCreation() {
  const user = selectUser();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { createNewDataset } = useCreateDataset();
  const isDatasetCreationV3Enabled = useFeatureFlagService(
    DATASET_INGESTION_ON_PREM,
  ).enabled;

  const handleDatasetCreation = async () => {
    const datasetCreationEnabled = (
      process.env.REACT_APP_DATASET_CREATION_FROM_UI_ENABLED || ""
    )
      .trim()
      .replace(/"/g, "");

    // Only show on-prem warning if dataset creation from UI is NOT explicitly enabled
    if (isOnPremUser() && datasetCreationEnabled !== "true") {
      dispatch(setShowDSCreationWarning(true));
      return;
    }

    if (datasetCreationEnabled !== "true") {
      return;
    }
    //check if user has not signed-in (only for non-onprem environments)
    if (!isOnPremUser() && (user === null || isAnonymousUser())) {
      dispatch(setShowSignUpModal(true));
      localStorage.setItem(SIGNUP_ORIGIN, CREATE_NEW_DATASET);
      return;
    }
    //open the new dataset creation flow
    dispatch(resetStore());

    const newDatasetId = await createNewDataset();

    if (newDatasetId) {
      if (isDatasetCreationV3Enabled) {
        navigate(`/dataset/${newDatasetId}/create/on-prem`);
      } else {
        navigate(`/dataset/${newDatasetId}/create`);
      }
    }
    return;
  };

  return { handleDatasetCreation };
}
